// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__b-Zkf","large":"styles_large__2iy45"};